import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';
import logo from 'assets/logo600.png';

const AppHeader = () => (
  <header className="header">
  <Link
  to={'/'}>
    <img src={logo} className="header-logo" alt="Logo Kaamelott" />
  </Link>
    <div className="header-title">Quiz Kaamelott</div>
    <Link
    className='scoreLink'
    to={'/scores'}
    >
      Scores
    </Link>
  </header>
);

export default AppHeader;
